import { ContactType } from '@/app/models/Contact';
import { DefaultConfig } from './_LayoutConfig';
import { AccountantLayoutConfig } from './_AccountantLayoutConfig';
import { SystemUserLayoutConfig } from './_SystemUserLayoutConfig';
import { type ILayout } from './_Models';
import { CommunityLayoutConfig } from './_CommunityLayoutConfig';

/**
 * Maps user types to their corresponding layout configurations.
 * Add new entries here when a new user type needs a custom layout.
 */
const LAYOUT_CONFIG_BY_USER_TYPE: Partial<Record<ContactType, ILayout>> = {
  [ContactType.ACCOUNTANT]: AccountantLayoutConfig,
  [ContactType.COMMUNITY]: CommunityLayoutConfig,
  [ContactType.SYSTEM_USER]: SystemUserLayoutConfig,
  [ContactType.ADMIN]: SystemUserLayoutConfig,
};

/**
 * Returns the appropriate layout configuration for the given user type.
 * Falls back to DefaultConfig when no specific layout is configured for the type.
 */
export function getLayoutConfigForUserType(userType?: ContactType): ILayout {
  if (!userType) return DefaultConfig;
  return LAYOUT_CONFIG_BY_USER_TYPE[userType] ?? DefaultConfig;
}
